import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {RoutePaths} from "../../util/constants";

const useFooterLinks = () => {
    const {t} = useTranslation()

    const exploreMore = useMemo(() => (
        {
            title: t('explore'),
            links: [
                {
                    label: t('about'),
                    path: RoutePaths.ABOUT
                },
                {
                    label: t('blogs'),
                    path: RoutePaths.BLOGS
                },
            ]
        }
    ), [t])

    const help = useMemo(() => (
        {
            title: t('help'),
            links: [
                {
                    label: t('contact'),
                    path: RoutePaths.CONTACT
                },
                {
                    label: t('guide'),
                    path: RoutePaths.GUIDE
                },
                {
                    label: t('faq_short'),
                    path: RoutePaths.FAQ
                },
            ]
        }
    ), [t])

    const legal = useMemo(() => (
        {
            title: t('legal'),
            links: [
                {
                    label: t('terms'),
                    path: RoutePaths.TERMS
                },
                {
                    label: t('privacy_footer'),
                    path: RoutePaths.PRIVACY
                }
            ]
        }
    ), [t])

    return {exploreMore, help, legal}
}

export default useFooterLinks
